import * as React from "react";
import styled from "styled-components/macro";
import * as fonts from "../../../styles/fonts";
import Bg1 from "../../../assets/images/1968.png";
import Bg2 from "../../../assets/images/19682.png";
import Bg3 from "../../../assets/images/19683.png";

export function Tooltip({ children, tooltipContent }) {
  const [show, setShow] = React.useState(false);

  const showToolTip = () => setShow(true);
  const hideToolTip = () => setShow(false);

  return (
    <div
      css={`
        position: relative;
      `}
      onMouseEnter={showToolTip}
      onMouseLeave={hideToolTip}
    >
      {children}
      {show ? (
        <div
          css={`
            position: absolute;
            left: 50%;
            top: 0;
            transform: translate(-50%, calc(-100% - 0.6em));
            background-color: #000;
            color: #fff;
            padding: 0.6em;
            font-size: 0.87em;
            font-family: ${fonts.three};
            border-radius: 0.3em;
            width: max-content;

            &::before {
              content: "";
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(45deg);
              height: 0.6em;
              width: 0.6em;
              background-color: #000;
            }
          `}
        >
          {tooltipContent}
        </div>
      ) : null}
    </div>
  );
}

export const BgImage = styled.img`
  width: 33.3%;
`;

export function BackgroundImage() {
  return (
    <div
      css={`
        position: absolute;
        left: 2em;
        bottom: 2em;
        width: 49%;
        height: 60%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: -1;
        opacity: 0.1;
      `}
    >
      <BgImage src={Bg2} alt="bg2" />
      <img
        src={Bg1}
        alt="bg1"
        width="100em"
        css={`
          align-self: flex-end;
        `}
      />
      <BgImage src={Bg3} alt="bg3" />
    </div>
  );
}
